import httpClient from '../http/http-client';
import { IApiEndpoint, IApiKey, IApiKeyLog, ICreateApiKey } from './api-key.model';

export default class ApiKeyService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async getAll(): Promise<IApiKey[]> {
    return this.http.get('api-key')
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(id: string): Promise<IApiKey> {
    return this.http.get(`api-key/${id}`)
      .then(response => {
        const data = response.data;
        // Sequelize may return the association under various names depending on the
        // model/alias used (e.g. apiEndpoints, ApiEndpoints, allowedEndpoints).
        // Normalise all variants onto the `endpoints` field.
        if (!data.endpoints) {
          data.endpoints =
            data.apiEndpoints ??
            data.ApiEndpoints ??
            data.allowedEndpoints ??
            data.AllowedEndpoints ??
            [];
        }
        console.log('[ApiKeyService] getOne response:', data);
        return data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(data: ICreateApiKey): Promise<IApiKey> {
    return this.http.post('api-key', data)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async remove(id: string): Promise<void> {
    return this.http.delete(`api-key/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getLogs(id: string, page: number = 0, perPage: number = 10): Promise<{ count: number; rows: IApiKeyLog[] }> {
    return this.http.get(`api-key/${id}/logs?page=${page}&perPage=${perPage}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllEndpoints(): Promise<IApiEndpoint[]> {
    return this.http.get('api-endpoint')
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async addEndpoints(keyId: string, endpointIds: string[]): Promise<void> {
    return this.http.post(`api-key/${keyId}/endpoints`, { endpointIds })
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async removeEndpoint(keyId: string, endpointId: string): Promise<void> {
    return this.http.delete(`api-key/${keyId}/endpoint/${endpointId}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}
